import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { useEditingVersionSnapshot } from '@/context/EditVersionContext/useEditVersionContext.ts';
import { StaticVersionResources } from '@/types/datasets.ts';
import { get_static_revision_selections_url } from '@/utils/urls.ts';

export default function useStaticVersionResources() {
  const api = useApiClient();
  const editingVersion = useEditingVersionSnapshot();
  return useQuery({
    queryKey: ['static-version-resources', editingVersion?.id],
    enabled: !!editingVersion?.id,
    queryFn: async () =>
      (
        await api.get<StaticVersionResources>(
          get_static_revision_selections_url(editingVersion!.id),
        )
      ).data,
  });
}
